var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_848_3375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.02 4.30514L19.6954 6.97924L17.02 4.30514ZM18.7404 1.94935L11.5063 9.18345C11.1325 9.55672 10.8776 10.0323 10.7737 10.5502L10.1055 13.895L13.4503 13.2256C13.9682 13.122 14.4432 12.8681 14.817 12.4942L22.0512 5.26009C22.2685 5.0427 22.441 4.78462 22.5586 4.5006C22.6763 4.21657 22.7368 3.91215 22.7368 3.60472C22.7368 3.29729 22.6763 2.99287 22.5586 2.70884C22.441 2.42481 22.2685 2.16673 22.0512 1.94935C21.8338 1.73196 21.5757 1.55952 21.2917 1.44187C21.0076 1.32422 20.7032 1.26367 20.3958 1.26367C20.0884 1.26367 19.7839 1.32422 19.4999 1.44187C19.2159 1.55952 18.9578 1.73196 18.7404 1.94935V1.94935Z",
    stroke: "#0397D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.211 16.4216V20.2111C20.211 20.8811 19.9449 21.5237 19.4711 21.9975C18.9973 22.4712 18.3547 22.7374 17.6847 22.7374H3.78999C3.11997 22.7374 2.47739 22.4712 2.00361 21.9975C1.52984 21.5237 1.26367 20.8811 1.26367 20.2111V6.31635C1.26367 5.64633 1.52984 5.00376 2.00361 4.52998C2.47739 4.0562 3.11997 3.79004 3.78999 3.79004H7.57946",
    stroke: "#0397D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_3375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminEditIcon);
export default __webpack_public_path__ + "static/media/admin-edit-icon.3bef7be31ab7e916e215ee424d5d1cc5.svg";
export { ForwardRef as ReactComponent };